import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _Object$create from 'babel-runtime/core-js/object/create';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import { debounce } from '@xunlei/thunder-ui-vue/lib/utils/util.js';

var NAMESPACE = 'td';

var Tree = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-tree td-tree--hover" }, _vm._l(_vm.copyData, function (node, index) {
      return _c('td-tree-node-plus', { key: _vm.bindingKeyGenerator(node), attrs: { "node": node, "lazy": _vm.lazy, "load": _vm.load, "levelPadding": _vm.levelPadding, "checkable": _vm.checkable }, model: { value: _vm.copyData[index], callback: function callback($$v) {
            _vm.$set(_vm.copyData, index, $$v);
          }, expression: "copyData[index]" } });
    }), 1);
  }, staticRenderFns: [],
  name: NAMESPACE + '-tree-plus',
  props: {
    data: {
      type: Array,
      required: true
    },
    lazy: {
      type: Boolean,
      default: false
    },
    load: {
      type: Function
    },
    levelPadding: {
      type: Number,
      default: 16
    },
    checkable: {
      type: Boolean,
      default: false
    },
    disableFunction: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    disableClass: {
      type: String,
      default: 'disabled-node'
    },
    bindingKeyGenerator: {
      type: Function,
      default: function _default(node) {
        return (node.__level || '') + ' ' + Math.random() + ' ' + node.title;
      }
    },
    defaultPlaceholder: {
      type: String,
      default: ''
    },
    nodeInsertionIconManifest: {
      type: Object,
      default: function _default() {
        return {
          visible: true,
          icon: 'https://backstage-img-ssl.a.88cdn.com/019fc2a136a2881181e73fea74a4836efc02195d'
        };
      }
    },
    expandWhenDoubleClick: {
      type: Boolean,
      default: false
    }
  },
  provide: function provide() {
    return {
      root: this
    };
  },
  data: function data() {
    return {
      copyData: [],
      // chooseNode 是一个TreeNode Instance
      chosenNode: null
    };
  },
  created: function created() {
    try {
      this.copyData = JSON.parse(_JSON$stringify(this.data));
    } catch (err) {
      this.copyData = [];
    }
    for (var i = 0; i < this.data.length; i++) {
      this.autoGeneratedKey(this.copyData[i], null);
    }
  },

  methods: {
    handleChangeNode: function handleChangeNode(node, index) {
      this.$set(this.copyData, index, node);
    },
    autoGeneratedKey: function autoGeneratedKey(treeNode, parentNode) {
      treeNode.__level = parentNode ? parentNode.__level + 1 : 1;
      var children = treeNode.children;
      if (children && children.length) {
        for (var i = 0; i < children.length; i++) {
          this.autoGeneratedKey(children[i], treeNode);
        }
      }
    }
  },
  watch: {
    chosenNode: function chosenNode(newVal) {
      this.$emit('changeChosenNode', newVal);
    }
  }
};

var TreeNode = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-tree-node is-expanded", class: _defineProperty({}, _vm.root.disableClass, _vm.isDisabledNode), staticStyle: { "user-select": "none" } }, [_c('div', { staticClass: "td-tree-node__content", class: { 'is-leaf': _vm.node.leaf, 'is-chosen': _vm.isChosen }, style: { paddingLeft: (_vm.node.__level - 1) * _vm.levelPadding + 'px' }, on: { "click": _vm.handleClickNodeContent, "dblclick": function dblclick($event) {
          _vm.root.expandWhenDoubleClick && _vm.handelClickExpandIcon();
        } } }, [_c('span', { staticClass: "td-tree-node__expand-icon td-icon-arrow-drop", class: [{ 'is-expanded': _vm.node.expand }], on: { "click": _vm.handelClickExpandIcon, "dblclick": function dblclick($event) {
          $event.stopPropagation();
        } } }), _vm._v(" "), _c('label', { directives: [{ name: "show", rawName: "v-show", value: _vm.checkable && !_vm.isInputLabel, expression: "checkable && !isInputLabel" }], staticClass: "td-checkbox", class: { 'is-indeterminate': _vm.indeterminate } }, [_c('input', { staticClass: "td-checkbox__inner", attrs: { "type": "checkbox" }, domProps: { "checked": !!_vm.node.checked }, on: { "click": _vm.handleClickCheckbox } })]), _vm._v(" "), _vm.lazy && _vm.loading ? _c('i', { staticClass: "td-icon-loading" }) : _c('span', { directives: [{ name: "show", rawName: "v-show", value: !_vm.isInputLabel || _vm.inputLabelIconVisible, expression: "!isInputLabel || inputLabelIconVisible" }], staticClass: "td-tree-node__image-icon", class: [_vm.node.iconClass], style: _vm.iconStyle }), _vm._v(" "), _c('span', { staticClass: "td-tree-node__label is-checked" }, [_vm.isInputLabel ? [_c('label', { staticClass: "td-input" }, [_c('span', { staticClass: "td-input__label" }), _vm._v(" "), _c('input', { ref: "createInput", staticClass: "td-input__inner", attrs: { "type": "text", "placeholder": "请输入文字" }, domProps: { "value": _vm.root.defaultPlaceholder }, on: { "keydown": function keydown($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
            return null;
          }$event.preventDefault();return _vm.handleConfirmInputCreate($event);
        }, "blur": _vm.handleConfirmInputCreate } })])] : [_vm._v(" " + _vm._s(_vm.node.title) + " ")]], 2)]), _vm._v(" "), _c('div', { staticClass: "td-tree-node__children" }, _vm._l(_vm.node.children, function (childNode, index) {
      return _c('td-tree-node-plus', { directives: [{ name: "show", rawName: "v-show", value: _vm.node.expand, expression: "node.expand" }], key: _vm.root.bindingKeyGenerator(childNode), attrs: { "node": childNode, "load": _vm.load, "lazy": _vm.lazy, "levelPadding": _vm.levelPadding, "isInputLabel": !!childNode.isInputLabel, "checkable": _vm.checkable }, on: { "createInputFinish": _vm.handleChildConfirmInputCreate }, model: { value: _vm.node.children[index], callback: function callback($$v) {
            _vm.$set(_vm.node.children, index, $$v);
          }, expression: "node.children[index]" } });
    }), 1)]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-tree-node-plus',
  model: {
    prop: 'node',
    event: 'change'
  },
  props: {
    node: {
      type: Object,
      required: true
    },
    lazy: {
      type: Boolean,
      default: false
    },
    load: {
      type: Function
    },
    levelPadding: {
      type: Number,
      default: 16
    },
    // 用来标记是否是一个输入框节点
    isInputLabel: {
      type: Boolean,
      default: false
    },
    checkable: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      indeterminate: false,
      loading: false,
      innerLazy: false,
      mode: '' // 当前只有两种mode， '' 和 'create'
      // create mode用来在当前节点的children中创建一个新的节点
    };
  },

  inject: ['root'],
  watch: {
    mode: function mode(newVal, oldVal) {
      if (newVal === 'create') {
        this.handleInCreateMode();
      }
    },

    'node.children.length': {
      handler: function handler(newVal) {
        this.node.leaf = !this.node.children.length;
        // this.node.children.sort((a, b) => a.__order - b.__order)
      }
    },
    'node.children': {
      deep: true,
      immediate: true,
      // 监听children 是否有变化，如果有变化，自己的checked 属性也需要及时更新
      handler: function handler() {
        if (this.$children && this.$children.length) {
          var allChecked = true;
          var allNotChecked = true;
          var anyChildIndeterminate = false;
          // 如果任意child的`indeterminate`是true，说明当前node 的所有子集至少有一个没有被选中，因此它的 `indeterminate` 也是true
          for (var i = 0; i < this.$children.length; i++) {
            if (this.$children[i].isInputLabel) {
              continue;
            }
            if (this.$children[i].indeterminate) {
              anyChildIndeterminate = true;
            }
            if (this.$children[i].node.checked) {
              allNotChecked = false;
            } else {
              allChecked = false;
            }
          }
          // 当一个node 的children 都是leaf时，这时不能根据他们的 `indeterminate` 来判断，因为leaf 的`indeterminate` 一定是false，
          // 所以根据所以子节点即不都被选中，也没有都不被选中来做 `indeterminate` 的状态依据
          var indeterminate = anyChildIndeterminate || !allChecked && !allNotChecked;
          // 当前 node 的`indeterminate` 修改时，它的所有祖先节点的 `indeterminate` 都有可能被修改，所以需要不断想上更新祖先节点的`indeterminate`状态
          if (indeterminate) {
            if (!allChecked) {
              var cur = this;
              while (cur && cur.$options._componentTag === 'td-tree-node-plus') {
                cur.indeterminate = indeterminate;
                cur = cur.$parent;
              }
            }
          } else {
            var _cur = this;
            while (_cur && _cur.$options._componentTag === 'td-tree-node-plus') {
              var _allChecked = _cur.$children.every(function (child) {
                return child.node.checked;
              });
              var _indeterminate = _cur.$children.some(function (child) {
                return child.indeterminate || child.node.checked;
              });
              _cur.indeterminate = !_allChecked && _indeterminate;
              _cur = _cur.$parent;
            }
            // 设置为false 时，有可能是最后一个indeterminate 要检测下 父级元素的所有child 是否有任意一个时indeterminate,这是一个递归的过程
          }
          var checked = allChecked;
          if (checked !== !!this.node.checked) {
            this.$set(this.node, 'checked', checked);
            this.$emit('change', this.node);
          }
        }
      }
    }
  },
  methods: {
    handleClickNodeContent: function handleClickNodeContent(event) {
      if (this.isDisabledNode) {
        event.preventDefault();
        return;
      }
      this.root.chosenNode = this;
    },
    updateChildren: function updateChildren(checked) {
      for (var i = 0; i < this.$children.length; i++) {
        this.$children[i].updateChildren(checked);
        this.$set(this.$children[i].node, 'checked', checked);
      }
    },

    // 这个函数是当子代node input，确认输入后，需要被从当前node.children 中删除时调用
    handleChildConfirmInputCreate: function handleChildConfirmInputCreate(childNode) {
      if (this.node.children && this.node.children.length) {
        var index = this.node.children.findIndex(function (node) {
          return node === childNode;
        });
        if (index !== -1) {
          this.node.children.splice(index, 1);
        }
      }
      this.mode = '';
    },
    handleClickCheckbox: function handleClickCheckbox() {
      if (this.indeterminate) {
        this.indeterminate = false;
        this.updateChildren(true);
        this.$set(this.node, 'checked', true);
      } else {
        this.updateChildren(!this.node.checked);
        this.$set(this.node, 'checked', !this.node.checked);
      }
      this.$emit('change', this.node);
    },

    // 这时当前node 节点是一个input 节点用来创建新的内容并确认后触发的函数
    handleConfirmInputCreate: debounce(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var refContent, refContentValue;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              refContent = this.$refs['createInput'];

              if (!refContent) {
                _context.next = 11;
                break;
              }

              refContentValue = refContent.value;
              _context.t0 = this.$parent.innerLazy;

              if (!_context.t0) {
                _context.next = 7;
                break;
              }

              _context.next = 7;
              return this.$parent.loadData();

            case 7:
              this.root.$emit('create', {
                chosenNode: this.$parent,
                content: refContentValue
              });
              this.$emit('createInputFinish', this.node);
              this.$parent.mode = '';
              this.root.isCreatingNode = true;

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    })), 10, undefined),
    handleInCreateMode: function handleInCreateMode() {
      var node = {
        __level: this.node.__level + 1,
        isInputLabel: true,
        leaf: true,
        // 这里是为了保证，加入虚拟节点，不会改变父级的checked 状态
        checked: this.node.checked,
        __order: this.node.children ? -this.node.children.length : 0
      };
      if (this.node.children) {
        this.node.children.push(node);
      } else {
        this.$set(this.node, 'children', [node]);
      }
      this.root.isCreatingNode = true;
      this.$set(this.node, 'expand', true);
    },
    loadData: function loadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, i;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this.loading = true;
                _context2.next = 4;
                return _this.load(_this.node);

              case 4:
                res = _context2.sent;

                if (res && res.length) {
                  for (i = 0; i < res.length; i++) {
                    _this.root.autoGeneratedKey(res[i], _this.node);
                  }
                  _this.$set(_this.node, 'children', res);
                  _this.innerLazy = false;
                }
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);

              case 11:
                _context2.prev = 11;

                _this.loading = false;
                return _context2.finish(11);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[0, 8, 11, 14]]);
      }))();
    },
    handelClickExpandIcon: function handelClickExpandIcon() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var nextExpandState;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this2.isDisabledNode) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                nextExpandState = !_this2.node.expand;

                if (!(nextExpandState && _this2.innerLazy && (!_this2.node.children || !_this2.node.children.length))) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 6;
                return _this2.loadData();

              case 6:
                _this2.$set(_this2.node, 'expand', nextExpandState);
                _this2.$emit('change', _this2.node);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    }
    // 根据层级和child所在下标自动生成key

  },
  computed: {
    inputLabelIconVisible: function inputLabelIconVisible() {
      return this.root.nodeInsertionIconManifest.visible;
    },
    iconStyle: function iconStyle() {
      var obj = _Object$create(null);
      if (this.node.icon) {
        obj['background-image'] = 'url(' + this.node.icon + ')';
      }
      if (this.isInputLabel) {
        var _root$nodeInsertionIc = this.root.nodeInsertionIconManifest,
            visible = _root$nodeInsertionIc.visible,
            icon = _root$nodeInsertionIc.icon;

        if (visible) {
          obj['background-image'] = 'url(' + icon + ')';
        }
        // 文件夹图片
      }
      return obj;
    },
    isDisabledNode: function isDisabledNode() {
      return this.root.disableFunction(this.node);
    },
    isChosen: function isChosen() {
      return this.root.chosenNode === this;
    }
  },
  mounted: function mounted() {
    if (process.env.NODE_ENV !== 'production') {
      if (this.lazy && !this.load) {
        console.warn('Load function must not be empty if lazy is true');
      }
    }
    // HACK: 边界情况，父级expand 为false， 子级中的checked 为true，因为被渲染，watch 走不到，所以这里hack下
    var expand = !!this.node.expand;
    this.$set(this.node, 'expand', true);
    this.$set(this.node, 'expand', expand);

    this.innerLazy = this.lazy;
    this.$refs['createInput'] && this.$refs['createInput'].focus();
    this.$refs['createInput'] && this.$refs['createInput'].select();
  }
};

Tree.install = function (Vue) {
  Vue.component(Tree.name, Tree);
  Vue.component(TreeNode.name, TreeNode);
};

export default Tree;
export { TreeNode };
